.previewImageDescription {
  padding-top: var(--space-6);

  :global(.ant-descriptions-item) {
    padding-bottom: var(--space-2) !important;
  }

  :global(.ant-descriptions-item-label) {
    color: #2d3436;
    font-weight: 600;
  }
}

.hashtag {
  color: #5b6b76;
  background: #f5f9fb;
  border-color: #b8c8d2;
  font-weight: 500;
}
